<script>
	import {Line, mixins} from 'vue-chartjs';
	import {Chart} from 'chart.js';
	import {_} from 'underscore';
	import {uniqueId} from "../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds";

	const {reactiveProp} = mixins;
	const vuejsChart = {
		this: this,
		chart: {}
	};
	//refer to link http://jsfiddle.net/mbhavfwm/506/
	const yAxisParams = {
		id: 'yAxisParams-id',
		chartWrapper: {},
		chart: {}
	};
	const chartPluginOverrides = {};
	export default {
		name: 'line_chart',
		extends: Line,
		mixins: [reactiveProp],
		props: ['chartWrapper', 'data', 'options', 'chartData', 'reloadChart'],
		created() {
		},
		destroyed() {
		},
		mounted() {
			vuejsChart.chart = this;
			/**
			 * Store the chart params for the y-axis and anything else parsed into the chart library
			 * @type {{id: *, width: *, chartWrapper: string, chart: *|null|Chart}}
			 */
			chartPluginOverrides[this.chartId] = {
				id: this.yAxisID,
				width: this.width,
				chartWrapper: this.chartWrapper,
				chart: this.$data._chart
			};

			this.$nextTick(function () {
				this.createChart();

			});
		},
		updated() {
			this.createChart();
		},
		data() {
			return {
				drillIntoData: {
					active: true,
					eventCallbackName: 'select_active_point'
				},
				yAxisID: uniqueId('y-axis-id'),
				setOptions: {},
				mergedOptions: {},
				defaultOptions: {
					title: {
						display: true,
						text: 'imn a title'
					},
					/**
					 * @link http://www.chartjs.org/docs/latest/general/interactions/modes.html?h=tooltip
					 */
					tooltips: {
						mode: 'index',
						intersect: false
					},
					/**
					 * On hover of the WHOLE chart
					 */
					// onHover:function(){
					//     console.log('test');
					// },
					legend: {
						display: false,// shows the clickable dataset legend. will toggle hide/show
						labels: {
							// This more specific font property overrides the global property
							// fontColor: '#ffffff'
						}
					},
					layout: {
						padding: { //in pixels
							left: 0,
							right: 0,
							top: 10,
							bottom: 0
						}
					},
					elements: {
						line: {
							tension: 0.2
						}
					},
					responsive: false, // my new default options
					maintainAspectRatio: false, // my new default options
					scaleShowGridLines: false,

					showScale: false,
					scales: {
						yAxes: [{
							ticks: {
								fontSize: 10,
								fontColor: this.readBodyColor(),
								beginAtZero: true,
// Include a dollar sign in the ticks
								callback: function (value, index, values) {
									return value;
									// return '$' + value;
								}
							},
							gridLines: {
								display: true
							}
						}],
						xAxes: [{
							ticks: {
								fontSize: 10,
								fontColor: this.readBodyColor()
							},
							gridLines: {
								display: false
							}
						}]
					},
					animation: {
						/**
						 * Creates the fixed label for scrolling by cloning the original and only showing a clipped version
						 * @link https://stackoverflow.com/questions/43247295/chart-js-v2-bar-chart-with-a-fixed-y-axis
						 */
						onComplete: function (data) {
							vuejsChart.chart.$emit('line_chart_loaded', 'line_chart');
							// console.log('onComplete',vuejsChart.chart);
							this.options.animation.onComplete = null; //disable after first render
							// console.log('data', data);

						}
					},
					/**
					 * Detect any click events on the canvas.
					 * @param evt
					 */
					onClick: function (evt) {
						/**
						 * Parse the selected data info back to vue
						 */
						if (vuejsChart.chart.drillIntoData.active == true) {
							let activePoint = this.lastActive[0];
							if (activePoint !== undefined) {
								let datasetIndex = activePoint._datasetIndex,
									index = activePoint._index,
									datasetName = this.config.data.datasets[datasetIndex].label,
									title = this.config.data.labels[index],
									dataValue = this.config.data.datasets[datasetIndex].data[index];
								// console.log(activePoint, index, datasetName, title, dataValue);
								vuejsChart.chart.emitActivePoint(activePoint, index, datasetName, title, dataValue);

							}
						}

					}
				}
			}
		},
		watch: {
			chartOptions() {
				console.log('this.options', this.options);
			},
			reloadChart() {
				this.createChart();

			},
			width: (newWidth, oldWidth) => {
				console.log(newWidth, oldWidth);
			}
		},
		computed: {},
		methods: {
			readBodyColor() {
				let elms = document.getElementsByClassName('dashboard-module');
				if (elms.length <= 0) {
					return 'red';
				}
				let elm = elms[0];
				console.log('readBodyColor', 'elm', elm);

				let css = window.getComputedStyle(elm);
				return css.color;
			},
			emitActivePoint(activePoint, index, datasetName, title, dataValue) {
				// console.log("Dataset Name: [" + datasetName + "] title: [" + title + "] value: [" + dataValue + "]");

				// define this because 'this' is the chart library not the vuejs library
				let _this = vuejsChart.chart;

				// console.log('_this',_this);

				_this.$emit(_this.drillIntoData.eventCallbackName, {
					action: 'drill-in',
					data: {
						activePoint: activePoint,
						index: index,
						datasetName: datasetName,
						title: title,
						dataValue: dataValue
					}
				});

			},
			createChart() {
				let cloneExists = document.getElementById(this.yAxisID);

				if (cloneExists !== null) {
					cloneExists.remove();
				}
				if (this.$data._chart != null) {
					this.$data._chart.destroy();
				}
				Object.assign(this.mergedOptions, this.defaultOptions, this.options);
// console.log('createChart', 'this.chartData',this.chartData);
				this.renderChart(this.chartData, this.mergedOptions);
				this.$data._chart.width = this.width;

			},
			onAnimationComplete() {
				let _this = vuejsChart.chart;
				_this.$emit('line_chart_loaded', 'line_chart');
				return;
				// noinspection JSAnnotator
				// console.log('vuejsChart.chart', vuejsChart.chart, vuejsChart.chart.mergedOptions);

				// if (_this.mergedOptions.responsive != true) {
				//     // create the scrollable y-axis
				//     let wrapperElement = document.getElementsByClassName(_this.chartWrapper.areaClass);
				//
				//     try {
				//         if (wrapperElement.length < 0) {
				//             throw 'no canvas wrapper found';
				//         }
				//     } catch (e) {
				//         console.log(e);
				//         return;
				//     }
				//     let cloneCanvas = document.getElementById(_this.yAxisID);
				//     if (cloneCanvas == null) {
				//         cloneCanvas = document.createElement('canvas');
				//         cloneCanvas.setAttribute('width', '0');
				//         cloneCanvas.setAttribute('id', _this.yAxisID);
				//
				//         cloneCanvas.style.position = 'absolute';
				//         cloneCanvas.style.left = '0';
				//         cloneCanvas.style.top = '0';
				//         cloneCanvas.style['pointer-events'] = 'none';
				//         cloneCanvas.setAttribute('height', `${_this.chartWrapper.chartHeight}`);
				//         /**
				//          * Apply to the wrapper
				//          */
				//         wrapperElement[0].appendChild(cloneCanvas);
				//     }
				//
				//     // console.log('_this.$data._chart', _this.$data._chart);
				//
				//     let chart = _this.$data._chart,
				//         getParentIdName = chart.canvas.attributes.id.value,
				//         targetElement = document.getElementById(_this.yAxisID), // the clone
				//         sourceElement = document.getElementById(getParentIdName),// the original
				//         sourceCanvas = chart.ctx.canvas,
				//         copyWidth = chart.scales['y-axis-0'].width - 5,
				//         copyHeight = chart.height - 20;
				//
				//     let targetElementWidth = sourceElement.getContext('2d').canvas.clientWidth,
				//         targetElementHeight = sourceElement.getContext('2d').canvas.clientHeight,
				//         targetCtx = targetElement.getContext('2d');
				//
				//     targetCtx.canvas.width = copyWidth;
				//     targetCtx.canvas.height = copyHeight;
				//     targetCtx.drawImage(sourceCanvas, 0, 0, targetElementWidth, targetElementHeight);
				//
				//     console.log('sourceCanvas', sourceCanvas);
				//
				// }
			},
			getLegend() {
				return this.$data._chart.generateLegend();
			},
			getScales() {
				return this.$data._chart.scales;
			},
			getCtx() {
				return this.$data._chart.chart.ctx;
			},
			getCanvas() {
				return this.$data._chart.chart.canvas;
			},
			getParent() {
				return this.$data._chart.chart.canvas.parentElement;
			},
			// get the data presented on the chart
			getDataSets() {

				return this.chartData.datasets || [];
			}
		}
	}
</script>
<style>
    .chartWrapper {
        position: relative;
    }

    /*.chartAreaWrapper canvas {*/
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
    /*pointer-events:none;*/
    /*}*/

    .chartAreaWrapper {
        width: 600px;
        overflow-x: scroll;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/LineChart.vue?7748d092